import styled from "styled-components";

const FiltersMain = styled.div`
    padding-top: 10px;
    padding-right: 24px;
    overflow: auto;
    max-width: 280px;
    // position: sticky;
    // top: 5px;
    @media screen and (max-width: 991px) {
        max-width: none;
        flex: initial;
        position: relative;
        padding-right: 10px;
        max-height: 300px;
        overflow: auto;
    }
    > .inner {
    }

    .filter-item {
        margin-bottom: 10px;
    }
`;

export default FiltersMain;
